import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import resolveResistPrintSideName from "../../../../../service/sideNameResolver/resolveResistPrintSideName"
import type { OneClickFieldProps } from "../../../../../types"
import ColorPattern from "../../../../components/1Click/form/ColorPattern/ColorPattern"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidResistPrint from "../../../../service/visibleValidator/isValidResistPrint"

const 塗布する面 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { resistPrint: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="塗布する面" helpURL={HELP_LINKS.塗布する面}>
      <RadioGroup
        name={FIELD_NAMES.塗布する面}
        selectedValue={values.resistPrint}
        onChange={handlers.radio}
        shouldRender={(value) => isValidResistPrint(values, value)}
      >
        <OneClickFieldStack>
          <Radio
            value={ESTIMATE_CONSTANT.塗布する面.両面に塗る.value}
            prefixNode={<ColorPattern pattern="both" values={values} />}
          >
            両面に塗る
          </Radio>
          <Radio
            value={ESTIMATE_CONSTANT.塗布する面["パターン面と同じ面に塗る(L1面に塗る)"].value}
            prefixNode={<ColorPattern pattern="top" values={values} />}
          >
            {resolveResistPrintSideName(
              ESTIMATE_CONSTANT.塗布する面["パターン面と同じ面に塗る(L1面に塗る)"].value,
              values
            )}
          </Radio>
          <Radio
            value={ESTIMATE_CONSTANT.塗布する面["パターン面とは逆の面に塗る(Ln面に塗る)"].value}
            prefixNode={<ColorPattern pattern="bottom" values={values} />}
          >
            {resolveResistPrintSideName(
              ESTIMATE_CONSTANT.塗布する面["パターン面とは逆の面に塗る(Ln面に塗る)"].value,
              values
            )}
          </Radio>
          <Radio
            value={ESTIMATE_CONSTANT.塗布する面.塗らない.value}
            prefixNode={<ColorPattern pattern="none" values={values} />}
          >
            塗らない
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.resistPrint} />
    </OneClickField>
  )
}

export default 塗布する面
